<template>
  <v-container>
    <TitleChip
      v-if="!isEditing"
      :title="'Cadastro ' + (invite.type == 'GERENTE' ? 'Gerencial' : 'Vendedor')"
    />
    <TitleChip
      v-if="isEditing"
      title="Editar Dados"
    />

    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step
          color="#0C4439"
          :complete="stepper > 1"
          step="1"
        />

        <v-divider />

        <v-stepper-step
          color="#0C4439"
          :complete="stepper > 2"
          step="2"
        />

        <v-divider />

        <v-stepper-step color="#0C4439" step="3" />
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card
            class="mb-2"
            color="transparent"
            flat
          >
            <h4 class="body-1 text-uppercase mb-3">
              Dados Pessoais
            </h4>
            <v-form
              ref="form"
              v-model="forms[0].valid"
              lazy-validation
            >
              <v-text-field
                v-if="!isEditing"
                id="email"
                v-model="seller.email"
                label="E-mail:"
                readonly
              />
              <v-text-field
                id="name"
                v-model="seller.name"
                label="Nome:"
                required
                :rules="rules"
              />
              <v-text-field
                id="lastName"
                v-model="seller.lastName"
                label="Sobrenome:"
                required
                :rules="rules"
              />
              <v-text-field
                id="nickname"
                v-model="seller.nickname"
                label="Apelido:"
                style="height: 90px;"
                required
                :rules="rules"
                hint="* Será utilizado como assinatura das suas campanhas. (Nome que aparece para o
                cliente)"
                persistent-hint
              />
              <v-text-field
                id="phone"
                v-model="seller.phone"
                label="Celular:"
                required
                :rules="rules"
                mask="(##) #####-####"
              />
              <v-radio-group
                v-model="seller.gender"
                row
              >
                <v-radio
                  class="mr-4"
                  label="Feminino"
                  color="#0C4439"
                  value="F"
                />
                <v-radio
                  class="mr-4"
                  label="Masculino"
                  color="#0C4439"
                  value="M"
                />
              </v-radio-group>
              <div
                class="buttonNext align-center"
                :class="{ buttonGroup: isEditing }"
              >
                <v-btn
                  v-if="isEditing"
                  color="#8A8691"
                  class="fontStyle"
                  round
                  outline
                  @click="$router.push(`/`)"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :disabled="!forms[0].valid"
                  class="fontStyle"
                  round
                  @click="validate(1)"
                >
                  Próximo
                  <v-icon
                    small
                    class="ml-1"
                  >
                    keyboard_arrow_right
                  </v-icon>
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card
            class="mb-2"
            color="transparent"
            flat
          >
            <h4 class="body-1 text-uppercase mb-3">
              Identificação
            </h4>

            <v-form
              ref="form2"
              v-model="forms[1].valid"
              lazy-validation
            >
              <v-autocomplete
                v-model="stores"
                :append-icon="isEditing ? 'lock' : 'keyboard_arrow_down'"
                :readonly="isEditing"
                :items="customer.stores"
                label="Loja"
                item-text="name"
                item-value="id"
                return-object
                small-chips
                multiple
                required
                :rules="storeRules"
              />

              <v-text-field
                v-model="seller.idERP"
                label="Código Vendedor:"
                style="height: 60px;"
              />
              <h5 class="caption mb-4">
                * Nós precisamos identificar você no sistema da marca. Caso possua, informe como
                você é identificado no sistema de frente de caixa/vendas.
              </h5>
              <v-checkbox
                v-show="invite.type == 'GERENTE'"
                v-model="isSeller"
                color="#0C4439"
                label="Também realizo vendas"
              />
            </v-form>
            <div class="buttonGroup align-center">
              <v-btn
                color="#8A8691"
                class="fontStyle"
                round
                outline
                @click="stepper = 1"
              >
                <v-icon
                  small
                  class="mr-1"
                >
                  keyboard_arrow_left
                </v-icon>
                Voltar
              </v-btn>

              <v-btn
                color="primary"
                :disabled="!forms[1].valid"
                class="fontStyle"
                round
                @click="validate(2)"
              >
                Próximo
                <v-icon
                  small
                  class="ml-1"
                >
                  keyboard_arrow_right
                </v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card
            class="mb-2"
            color="transparent"
            flat
          >
            <h4 class="body-1 text-uppercase mb-3">
              {{ isEditing ? "Redefinição de Senha" : "Definição de Senha" }}
              <span
                v-if="isEditing"
                class="caption text-none"
              >(Campo não obrigatório)</span>
            </h4>
            <v-form
              ref="form3"
              v-model="forms[2].valid"
            >
              <v-text-field
                v-if="!isEditing"
                v-model="password"
                :label="isEditing ? 'Senha Atual:' : 'Senha:'"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :type="show ? 'text' : 'password'"
                :rules="[passwordRules.required, passwordRules.min]"
                @click:append="show = !show"
              />
              <v-text-field
                v-if="!isEditing"
                v-model="repassword"
                label="Repetir Senha:"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :type="show ? 'text' : 'password'"
                :rules="[passwordRules.required, passwordRules.min, passwordRules.passwordMatches]"
                @click:append="show = !show"
              />
              <v-text-field
                v-if="isEditing"
                v-model="newPassword"
                label="Nova Senha:"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :type="show ? 'text' : 'password'"
                :rules="[passwordRules.min]"
                @click:append="show = !show"
              />
              <v-text-field
                v-if="isEditing"
                v-model="newRepassword"
                label="Repetir Nova Senha:"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :type="show ? 'text' : 'password'"
                :rules="[passwordRules.min, passwordRules.newPasswordMatches]"
                @click:append="show = !show"
              />
              <div class="buttonGroup">
                <v-btn
                  color="#8A8691"
                  class="fontStyle"
                  round
                  outline
                  @click="stepper = 2"
                >
                  <v-icon
                    small
                    class="mr-1"
                  >
                    keyboard_arrow_left
                  </v-icon>
                  Voltar
                </v-btn>

                <div class="text-xs-center">
                  <v-btn
                    v-if="!isEditing"
                    :disabled="!forms[2].valid"
                    color="primary"
                    class="fontStyle"
                    round
                    :loading="loading"
                    @click="createSeller()"
                  >
                    Criar Conta!
                  </v-btn>
                  <v-btn
                    v-if="isEditing"
                    color="primary"
                    class="fontStyle"
                    round
                    :loading="loading"
                    @click="saveSeller()"
                  >
                    Salvar!
                  </v-btn>
                </div>
              </div>
            </v-form>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        top
        right
        :color="snackColor"
      >
        {{ snackText }}
        <v-btn
          color="white"
          icon
          outline
          small
          text
          @click="snackbar = false"
        >
          <v-icon small>
            close
          </v-icon>
        </v-btn>
      </v-snackbar>
    </v-stepper>
  </v-container>
</template>

<script>
/* eslint-disable max-len */
import phoneSanitizer from '../resources/sanitizers/phone';
import { EventBus } from '../event-bus';
import {
  CreateSeller, FindSellerById, CustomerBySellerId, SaveSeller, CheckSellerCPF, CheckSellerIdERPAndAlternateId,
} from '../apollo';

export default {
  props: {
    isEditing: Boolean,
  },
  data() {
    return {
      isSeller: false,
      forms: [
        { valid: false, form: null },
        { valid: false, form: null },
        { valid: false, form: null },
      ],
      loading: false,
      loader: null,
      stepper: 0,
      show: false,
      password: null,
      repassword: null,
      newPassword: null,
      newRepassword: null,
      customer: {},
      stores: null,
      passwordRules: {
        required: (value) => !!value || 'Campo Obrigatório',
        min: (v) => (v && v.length >= 8) || 'Mínimo de 8 caracteres',
        passwordMatches: (v) => v === this.password || 'As senhas não conferem.',
        newPasswordMatches: (v) => v === this.newPassword || 'As senhas não conferem.',
      },
      storeRules: [(v) => (!!v && v.length > 0) || 'Campo obrigatório'],
      rules: [(v) => !!v || 'Campo obrigatório'],
      dialogSuccess: false,
      invite: {},
      seller: {
        email: undefined,
      },
      timeout: 2000,
      snackbar: false,
      snackText: '',
      snackColor: '#FFADDE',
      multiline: false,
    };
  },
  computed: {
    sellerId() {
      return this.$auth.user.rootSub || this.$auth.user.sub;
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      // eslint-disable-next-line no-return-assign
      setTimeout(() => (this[l] = false), 4000);
      this.loader = null;
    },
  },
  mounted() {
    this.customer = JSON.parse(localStorage.getItem('inviteCustomer'));
    this.invite = localStorage.getItem('invite') ? JSON.parse(localStorage.getItem('invite')) : {};
    this.seller.email = localStorage.getItem('inviteEmail') || undefined;
    this.forms[0].form = this.$refs.form;
    this.forms[1].form = this.$refs.form2;
    this.forms[2].form = this.$refs.form3;
    if (this.isEditing) {
      this.getSeller();
      this.getCustomerBySellerId();
    }
  },
  methods: {
    async getCustomerBySellerId() {
      const res = await this.$apollo.query({
        query: CustomerBySellerId,
        variables: {
          sellerId: this.sellerId,
        },
        fetchPolicy: 'no-cache',
      });
      this.customer = res.data.customerBySellerId;
      const stores = [];
      if (this.isEditing) {
        this.customer.stores.forEach((stor) => {
          const seller = stor.sellers.find((sell) => sell._id === this.sellerId);
          if (seller) stores.push(stor);
        });
        this.stores = stores;
      }
    },
    async getSeller() {
      const res = await this.$apollo.query({
        query: FindSellerById,
        variables: {
          id: this.sellerId,
        },
        fetchPolicy: 'no-cache',
      });
      const seller = res.data.findSellerById;
      const splittedName = seller.name.split(' ');
      const [firstName, ...lastNames] = splittedName;
      seller.name = firstName;
      seller.lastName = lastNames.join(' ');
      seller.phone = `${seller.phoneArea} ${seller.phone}`;
      this.seller = seller;
    },
    async saveSeller() {
      this.loader = 'loading';
      const phone = await phoneSanitizer(this.seller.phone);
      const name = this.seller.name.replace(/\s+/g, ' ').trim();
      const lastName = this.seller.lastName.replace(/\s+/g, ' ').trim();
      const email = this.seller.email.trim();
      await this.$apollo.query({
        query: SaveSeller,
        variables: {
          seller: {
            _id: this.sellerId,
            name: `${name} ${lastName}`,
            nickname: this.seller.nickname,
            phone: phone.phone,
            phoneArea: phone.phoneArea,
            cpf: this.seller.cpf,
            seller: this.seller.seller,
            manager: this.seller.manager,
            director: this.seller.director,
            idERP: this.seller.idERP,
            email,
            gender: this.seller.gender,
            password: this.newPassword,
            termsOfUse: {
              termVersion: this.seller.termsOfUse.termVersion,
              sellerIP: this.seller.termsOfUse.sellerIP,
              acceptDate: this.seller.termsOfUse.acceptDate,
            },
          },
        },
        fetchPolicy: 'no-cache',
      });
      this.emitSnackBar('Perfil salvo com sucesso!');
      this.$router.push('/');
    },
    async validate(step) {
      let validCPFIdERP = true;

      if (this.isEditing) {
        validCPFIdERP = true;
      } else if (this.seller.idERP || this.seller.alternateIds) {
        validCPFIdERP = (await this.checkSellerIdERPAndAlternateId()).checkSellerIdERPAndAlternateId;
      }

      this.forms[step - 1].valid = this.forms[step - 1].form.validate();

      if (this.forms[step - 1].valid && validCPFIdERP) {
        this.stepper = step + 1;
      }
    },
    async createSeller() {
      this.loader = 'loading';
      this.forms[2].valid = this.forms[2].form.validate();
      if (this.forms.every((f) => f.form.validate())) {
        const phone = await phoneSanitizer(this.seller.phone);
        const name = this.seller.name.replace(/\s+/g, ' ').trim();
        const lastName = this.seller.lastName.replace(/\s+/g, ' ').trim();
        const email = this.seller.email.trim();
        await this.$apollo.query({
          query: CreateSeller,
          variables: {
            customerId: this.customer.id,
            storeIds: Array.isArray(this.stores) ? this.stores.map((s) => s.id) : [this.stores.id],
            code: this.invite.code,
            seller: {
              name: `${name} ${lastName}`,
              nickname: this.seller.nickname,
              phone: phone.phone,
              phoneArea: phone.phoneArea,
              cpf: this.seller.cpf,
              seller: this.invite.type === 'VENDEDOR' || this.isSeller,
              manager: this.invite.type === 'GERENTE',
              idERP: this.seller.idERP,
              email,
              gender: this.seller.gender,
              password: this.password,
            },
          },
          fetchPolicy: 'no-cache',
        });
      }
      this.emitSnackBar('Perfil criado com sucesso!');
      this.$router.push('/');
    },
    async checkSellerCPF() {
      const res = await this.$apollo.query({
        query: CheckSellerCPF,
        variables: {
          customerId: this.customer.id,
          seller: {
            cpf: this.seller.cpf,
          },
        },
        fetchPolicy: 'no-cache',
      });
      return res.data;
    },
    async checkSellerIdERPAndAlternateId() {
      const res = await this.$apollo.query({
        query: CheckSellerIdERPAndAlternateId,
        variables: {
          customerId: this.customer.id,
          seller: {
            idERP: this.seller.idERP,
            alternateIds: this.seller.alternateIds,
          },
        },
        fetchPolicy: 'no-cache',
      });
      return res.data;
    },
    emitSnackBar(text) {
      const snackBar = {};
      snackBar.text = text;
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
  },
};
</script>

<style scoped>

.v-btn {
  border-radius: 7.08982px !important;
}

.ajustScreen {
  min-height: 600px;
  padding: 0;
  margin-top: 138px;
}

.positionRegister {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
}

.positionFields {
  flex-direction: column;
  align-items: center;
  width: 70%;
  margin: auto;
  margin-bottom: 30px;
}

.positionButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: auto;
}

.position {
  margin-top: 100px;
}

.fontColor {
  color: #099ab1;
}

.fontStyle {
  text-transform: capitalize;
  font-weight: lighter;
}

.v-stepper {
  box-shadow: none;
  background-color: transparent;
}

.v-stepper__header {
  box-shadow: none;
}

.buttonNext {
  display: flex;
  justify-content: flex-end;
}

.buttonGroup {
  display: flex;
  justify-content: space-between;
}

</style>
